import FormSetNumber from '../../../../components/form-set-number/form-set-number'
import { onCellStandard, renderShipment } from '../../helpers/helpers'
import type { ShipmentColumn } from '../../types/column-types'

export const formSetColumn: ShipmentColumn = {
    key: 'formSet',
    dataIndex: ['form_set', 'id'],
    title: (
        <>
            Набор <br />
            форм
        </>
    ),
    width: 70,
    onCell: onCellStandard,
    render: renderShipment(r => {
        const formSet = r.form_set
        if (!formSet?.documentId) return null
        return <FormSetNumber formSet={formSet} />
    }),
}
